class CarouselAnalyticsTracker {
    constructor() {
        this.seenLists = new Set();
        this.observer = null;
        this.mutationObserver = null;
    }

    getListPayload(listId) {
        const script = document.querySelector(`script[data-tracking-list-id="${listId}"]`);
        if (!script) return null;

        try {
            const data = JSON.parse(script.textContent);
            if (!Array.isArray(data.items)) return null;

            return {
                item_list_id: listId,
                item_list_name: data.list_name || listId,
                items: data.items
            };
        } catch (e) {
            console.warn(`Invalid JSON in carousel script for "${listId}"`, e);
            return null;
        }
    }

    publishViewItemList(payload) {
        if (typeof window.Shopify?.analytics?.publish === 'function') {
            window.Shopify.analytics.publish('forix:item_list', payload);
        } else {
            console.warn('Shopify analytics not ready.');
        }
    }

    observeCarousels() {
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) return;

                const el = entry.target;
                const listId = el.dataset.trackingListId;
                if (!listId || this.seenLists.has(listId)) return;

                const payload = this.getListPayload(listId);
                if (payload) {
                    this.publishViewItemList(payload);
                    this.seenLists.add(listId);
                }
            });
        }, { threshold: 0 });

        // Observe existing elements
        this.observeExistingElements();

        // Start watching for new elements
        this.startMutationObserver();
    }

    observeExistingElements() {
        document.querySelectorAll('div[data-tracking-list-id]').forEach(el => {
            this.observer.observe(el);
        });
    }

    startMutationObserver() {
        this.mutationObserver = new MutationObserver((mutations) => {
            mutations.forEach(mutation => {
                // Check for added nodes
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        // Check if the added node itself has the attribute
                        if (node.hasAttribute && node.hasAttribute('data-tracking-list-id')) {
                            this.observeElement(node);
                        }

                        // Check children of the added node
                        const childrenWithTracking = node.querySelectorAll && node.querySelectorAll('div[data-tracking-list-id]');
                        if (childrenWithTracking) {
                            childrenWithTracking.forEach(child => {
                                this.observeElement(child);
                            });
                        }
                    }
                });
            });
        });

        // Start observing the entire document for changes
        this.mutationObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    observeElement(el) {
        const listId = el.dataset.trackingListId;
        if (listId && !this.seenLists.has(listId)) {
            this.observer.observe(el);
        }
    }

    init() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.observeCarousels());
        } else {
            this.observeCarousels();
        }
    }

    destroy() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
        if (this.mutationObserver) {
            this.mutationObserver.disconnect();
            this.mutationObserver = null;
        }
        this.seenLists.clear();
    }
}

// Initialize the tracker
const carouselTracker = new CarouselAnalyticsTracker();
carouselTracker.init();

window.addEventListener('DOMContentLoaded', () => {
    function getQueryParam(param) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }
    const searchQuery = getQueryParam('_psq');
    const isSearchPage = window.location.pathname.includes('/search');
    if (searchQuery && !isSearchPage) {
        sendGAEvent('forix:autocomplete_search', {
            search_term: searchQuery,
        });
        sendGAEvent('view_search_results', {
            search_term: searchQuery,
        });
    }
    function sendGAEvent(eventName, eventData) {
        if (typeof window.Shopify?.analytics?.publish === 'function') {
            window.Shopify.analytics.publish(eventName, eventData);
        } else {
            console.warn('GA4 is not initialized.');
        }
    }
});